<template>
  <div>
    <!-- hide only on large scroeen  -->
    <v-toolbar dense flat class="top-nav white--text d-lg-none">
      <v-app-bar-nav-icon @click.native="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="text-weight-400 dashboard--title">
        CBDRTBC Dashboard
      </v-toolbar-title>
    </v-toolbar>
    <!-- / -->

    <v-navigation-drawer v-model="drawer" app>
      <v-sheet
        color="purple accent-4"
        class="d-flex flex-column justify-center pa-4"
      >
        <div class="white--text project--title text-uppercase text-center pb-1">
          CBDRTBC Project
        </div>
        <div class="py-2 pr-2">
          <v-img
            contain
            src="./../../assets/static-images/title.svg"
            aspect-ratio="3.9"
          />
        </div>
      </v-sheet>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon> mdi-home-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <div v-if="isRoleProgram">
          <v-list-group :prepend-icon="accounts[0].icon">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ accounts[0].text }} </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="item in isRoleMnE"
              :key="item.text"
              :to="item.route"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-group :prepend-icon="basicData[0].icon">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ basicData[0].text }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="item in basicData[0].items"
              :key="item.text"
              :to="item.route"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

        </div>
       
        <v-list-item
          v-for="item in remainingItems"
          :key="item.text"
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group :prepend-icon="exportLists[0].icon">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ exportLists[0].text }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="item in exportLists[0].items"
              :key="item.text"
              :to="item.route"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list-group>

        <!-- hide  on large scroeen  -->
        <v-list-item class="d-lg-none" @click="showChangePassword">
          <v-list-item-icon>
            <v-icon> mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Change Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="d-lg-none" @click="logout">
          <v-list-item-icon>
            <v-icon> mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    drawer: true,
    mNe: 3,
    program: 4,
    accounts: [
      {
        text: "Users",
        icon: "mdi-account-group-outline",
        items: [
          {
            text: "Admins",
            icon: "mdi-shield-account-outline",
            route: "/admins",
          },
          {
            text: "FO",
            icon: "mdi-face-shimmer-outline",
            route: "/pa",
          },
          {
            text: "DA",
            icon: "mdi-face-outline",
            route: "/da",
          },
          {
            text: "Clinic account",
            icon: "mdi-face-outline",
            route: "/clinic",
          },
          {
            text: "Member",
            icon: "mdi-face-outline",
            route: "/member",
          },
        ],
      },
    ],
    patient: [
      {
        text: "Patient",
        icon: "mdi-account-heart-outline",
        route: "/patient",
      },
    ],
    volunteer: [
      {
        text: "Volunteer",
        icon: "mdi-account-outline",
        route: "/volunteer",
      },
    ],
    report: [
      {
        text: "Report",
        icon: "mdi-clipboard-file-outline",
        route: "/report",
      },
    ],
    dataImport: [
      {
        text: "Data Import",
        icon: "mdi-home-outline",
        route: "/data-import",
      },
    ],

    innoDOT: [
      {
        text: "Inno DOT",
        icon: "mdi mdi-information-box-outline",
        route: "/inno-dot",
      },
    ],
    exportLists: [
      {
        text: "Exports",
        icon: "mdi-printer",
        items: [
          {
            text: "CI Export",
            icon: "mdi-book-arrow-right-outline",
            route: "/ci-export",
          },
          {
            text: "Complementary Export",
            icon: "mdi-book-arrow-right",
            route: "/complementary-export",
          },
          {
            text: "DOT Patient Export",
            icon: "mdi mdi-pill",
            route: "/dots-patient-export",
          },
          {
            text: "DOT Visit Export",
            icon: "mdi-calendar-clock",
            route: "/dots-visit-export",
          },
          {
            text: "Enroll Patient Export",
            icon: "mdi-account-group",
            route: "/enroll-patient-export",
          },
          {
            text: "Family Member",
            icon: "mdi-account-group-outline",
            route: "/familymember-export",
          },
          {
            text: "Outcome Export",
            icon: "mdi-file-table-box-outline",
            route: "/outcome-export",
          },
          {
            text: "Presumptive Export",
            icon: "mdi-file-table-box",
            route: "/presumptive-export",
          },
          {
            text: "Side Effect Export",
            icon: "mdi-allergy",
            route: "/side-effect-export",
          },
          {
            text: "",
            icon: "",
          },
        ],
      },
    ],
    
    activity: [
      {
        text: "Activity",
        icon: "mdi-charity",
        route: "/activity",
      },
    ],
    basicData: [
      {
        text: "Basic Data",
        icon: "mdi-script-text-outline",
        items: [
          {
            text: "Initial Data",
            icon: "mdi-database-plus-outline",
            route: "/initial-data",
          },
          {
            text: "Region",
            icon: "mdi-web",
            route: "/region",
          },
          {
            text: "Township Group",
            icon: "mdi-domain",
            route: "/township-group",
          },
          {
            text: "Township",
            icon: "mdi-city",
            route: "/township",
          },
          {
            text: "Sympton",
            icon: "mdi-remote",
            route: "/sympton",
          },
          {
            text: "Risk Factor",
            icon: "mdi-boom-gate-alert-outline",
            route: "/risk_factor",
          },
          {
            text: "Side effect",
            icon: "mdi-allergy",
            route: "/side_effect",
          },
          {
            text: "Procedure",
            icon: "mdi-transit-connection",
            route: "/procedure",
          },
        ],
      },
    ],
    exportList: [
      {
        text: "Export",
        icon: "mdi-script-text-outline",
        items: [
          {
            text: "Initial Data",
            icon: "mdi-database-plus-outline",
            route: "/initial-data",
          },
          {
            text: "Region",
            icon: "mdi-web",
            route: "/region",
          },
          {
            text: "Township Group",
            icon: "mdi-domain",
            route: "/township-group",
          },
          {
            text: "Township",
            icon: "mdi-city",
            route: "/township",
          },
          {
            text: "Sympton",
            icon: "mdi-remote",
            route: "/sympton",
          },
          {
            text: "Risk Factor",
            icon: "mdi-boom-gate-alert-outline",
            route: "/risk_factor",
          },
          {
            text: "Side effect",
            icon: "mdi-allergy",
            route: "/side_effect",
          },
          {
            text: "Procedure",
            icon: "mdi-transit-connection",
            route: "/procedure",
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapState("Admin", ["admin"]),
    isRoleProgram() {
      if (this.changeToNumber(this.admin.role) === this.program) return false;
      return true;
    },
    isRoleMnE() {
      if (this.changeToNumber(this.admin.role) === this.mNe) {
        return this.accounts[0].items.filter((item) => item.text != "Admins");
      }
      return this.accounts[0].items;
    },
    remainingItems() {
      if (this.changeToNumber(this.admin.role) === this.program) {
        return [
          ...this.patient,
          ...this.volunteer,
          ...this.activity,
          ...this.report,
          //  ...this.dataImport,
          //...this.innoDOT,
        ];
      }
      return [
        ...this.patient,
        ...this.volunteer,
        ...this.activity,
        ...this.report,
        //...this.dataImport,
        ...this.innoDOT,
      ];
    },
  },
  methods: {
    showChangePassword() {
      this.$store.dispatch("Admin/setDialog");
    },
    changeToNumber(value) {
      return typeof value === "string" ? Number(value) : value;
    },
    logout() {
      this.$store.dispatch("Admin/logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style scoped>
.project--title {
  letter-spacing: 3px;
  font-weight: 300 !important;
}
.v-list .v-list-item--active {
  color: var(--primary-color);
}
.v-list-group .v-list-group--active {
  color: grey !important;
}
.top-nav {
  box-shadow: var(--primary-box-shadow) !important;
  background-image: linear-gradient(
    to top,
    #aa00ff,
    #ad10fd,
    #af1bfc,
    #b223fa,
    #b42af9
  );
}
.v-toolbar__title {
  cursor: pointer;
}
.dashboard--title {
  font-weight: 300 !important;
  letter-spacing: 2px;
  font-size: 17px;
}
</style>
